import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { TestimonialsShort } from './components/TestimonialsShort';
import { Problem } from './components/Problem';
import { Product } from './components/Product';
import { Bonos } from './components/Bonos';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { SistemaPro } from './components/SistemaPro';
import { TestimonialsExtended } from './components/TestimonialsExtended';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-violet selection:text-white overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <Stats data-id="element-2" />
      <TestimonialsShort data-id="element-3" />
      <Problem data-id="element-4" />
      <Product data-id="element-5" />
      <Bonos data-id="element-6" />
      <Urgency data-id="element-7" />
      <Pricing data-id="element-8" />
      <SistemaPro data-id="element-9" />
      <TestimonialsExtended data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <CostOfInaction data-id="element-13" />

      {/* Final CTA Section (Repeats Urgency and Pricing) */}
      <div className="py-20 bg-gradient-to-b from-brand-dark to-black border-t border-white/10" data-id="element-14">
        <div className="text-center mb-12" data-id="element-15">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-16">
            🔁 NO DEJES PASAR ESTA OPORTUNIDAD
          </h2>
        </div>
        <Urgency data-id="element-17" />
        <Pricing data-id="element-18" />

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mt-12 max-w-3xl mx-auto px-4" data-id="element-19">
          <span className="flex items-center gap-2" data-id="element-20">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-2" data-id="element-21">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-22">
            🛡️ Garantía 7 días sin preguntas
          </span>
          <span className="flex items-center gap-2" data-id="element-23">
            💳 Mercado Pago | Tarjeta | Transferencia
          </span>
          <span className="flex items-center gap-2" data-id="element-24">
            📄 100% PDF — Sin apps ni plataformas
          </span>
        </div>
      </div>

      <Footer data-id="element-25" />
    </div>;
}